//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";

export default {

	data() {
		return {
			hotsinger: '',

		}
	},
	methods: {
		sort: function() {

			var salf = this
			axios.get("https://bird.ioliu.cn/v1?url=http://m.kugou.com/singer/class&json=true")
				.then((response) => {
					var sing = response.data.list;

					salf.hotsinger = sing;

				})
				.catch((error) => {
					console.log(error);
				});
		},
		singerlist(getid, title) {

			window.location.href = "#/singlist/" + getid;
			window.localStorage.setItem("name", title)
		}
	},
	mounted() {
		this.sort();
	}

}



// WEBPACK FOOTER //
// ./src/components/ZhenV_RT/xtotallist.vue